import React from 'react';
import styles from './index.module.scss';

const ModalPopup = ({ visible, onClose, children }) => {
  const [show, setShow] = React.useState(visible);
  const [closing, setClosing] = React.useState(false);

  React.useEffect(() => {
    if (visible) {
      setShow(true);
      setClosing(false);
      document.body.style.overflow = 'hidden';
    } else if (show) {
      setClosing(true);
      setTimeout(() => {
        setShow(false);
        setClosing(false);
        document.body.style.overflow = '';
      }, 300);
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [visible]);

  if (!show) return null;
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={closing ? `${styles.popup} ${styles.slideDown}` : styles.popup}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.closeBtn} onClick={onClose}></div>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default ModalPopup;
